// material ui
import { Box, Typography } from '@mui/material';

// feature-utils
import {
  SEVERITY_COLORS,
  SEVERITY_LEVEL_MAP,
} from '@/features/alarm-hub/utils/alarmTypeIconMap';

const SeverityBars = ({ severity, label, showLabel = true }) => {
  const activeBars = SEVERITY_LEVEL_MAP[severity] ?? 0;
  const color = SEVERITY_COLORS[severity] || SEVERITY_COLORS.Unknown;
  const labelText = label ?? severity ?? '-';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 0.25,
        }}
      >
        {Array.from({ length: 6 }).map((_, index) => {
          const barNumber = index + 1;
          const isActive = barNumber <= activeBars;

          return (
            <Box
              key={barNumber}
              sx={{
                width: 3,
                height: 14,
                borderRadius: '2px',
                backgroundColor: isActive ? color : 'action.disabledBackground',
                transition: 'background-color 160ms ease',
              }}
            />
          );
        })}
      </Box>
      {showLabel ? (
        <Typography variant="body2" noWrap sx={{ color: 'text.primary' }}>
          {labelText}
        </Typography>
      ) : null}
    </Box>
  );
};

export { SeverityBars };
